import {
  type CatalogProduct,
  type ProductCategory,
} from 'src/types/backendContent';

export type CategoryWithProducts = {
  category: ProductCategory;
  products: CatalogProduct[];
};

export const getCategoryProductMap = (
  categories: ProductCategory[],
  products: CatalogProduct[],
  categoryFilter: string | undefined,
): CategoryWithProducts[] =>
  categories
    .map((category) => ({
      category,
      products: products.filter((product) =>
        (product.categories || []).some(
          (productCategory) => productCategory.id === category.id,
        ),
      ),
    }))
    .filter(
      (category) =>
        category.products.length > 0 &&
        (categoryFilter ? category.category.slug === categoryFilter : true),
    );
